<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-select size="small" v-if="isAdmin" @change="agentChange" v-model="query.agentId" filterable
					clearable placeholder="代理商" class="handle-select mr10" style="width: 260px">
					<el-option v-for="item in agents" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-select size="small" v-if="isNormal || isAgent" v-model="query.companyId" @change="companyChange"
					filterable clearable placeholder="企业" class="handle-select mr10" style="width: 260px">
					<el-option v-for="item in companys" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-select size="small" v-model="query.cardsId" filterable clearable placeholder="请选择品牌"
					class="handle-select mr10" style="width: 140px">
					<el-option v-for="item in serverLists" :key="item.cardsId" :label="item.cardType"
						:value="item.cardsId"></el-option>
				</el-select>
				<el-select size="small" v-model="query.type" filterable clearable placeholder="类型"
					class="handle-select mr10" style="width: 140px">
					<el-option v-for="item in typeList" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-input size="small" v-model="query.phone" clearable placeholder="请输入手机号码" class="handle-input mr10"
					style="width: 140px"></el-input>
				<el-date-picker size="small" v-model="timeArr" type="month" class="m_r_10"></el-date-picker>
				<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
					@click="handleSearch">搜索</el-button>
				<el-button size="small" type="primary" :class="[theme]" icon="el-icon-download"
					@click="handleExport">导出</el-button>
			</div>

			<div style="display: flex;flex-direction: row;margin-bottom: 20px;justify-content: space-between;">
				<div class="phone-details">
					<div class="title">销售总额<el-tooltip content="套餐包销售额/加量包销售额/总销售额" placement="top">
							<i class="el-icon-warning-outline"
								style="color: #f27c27;position: relative;top:-4px;left: 6px;cursor: pointer;"></i>
						</el-tooltip></div>
					<span
						class="text">{{customData.packagePrice||0}}元/{{customData.outsidePackagePrice||0}}元/{{(customData.packagePrice)+(customData.outsidePackagePrice)||0}}元</span>
				</div>
				<div class="phone-details">
					<div class="title">溢价总额<el-tooltip content="套餐包溢价金额/加量包溢价金额/总溢价金额" placement="top">
							<i class="el-icon-warning-outline"
								style="color: #f27c27;position: relative;top:-4px;left: 6px;cursor: pointer;"></i>
						</el-tooltip></div>
					<span
						class="text">{{customData.packagePriceDiff||0}}元/{{customData.outsidePackagePriceDiff||0}}元/{{(customData.outsidePackagePriceDiff)+(customData.packagePriceDiff)||0}}元</span>
				</div>
				<div class="phone-details">
					<div class="title">订购坐席数<el-tooltip content="套餐开户人数/加量包开户人数/总人数" placement="top">
							<i class="el-icon-warning-outline"
								style="color: #f27c27;position: relative;top:-4px;left: 6px;cursor: pointer;"></i>
						</el-tooltip></div>
					<span
						class="text">{{customData.baseRecordCount||0}}个/{{customData.outsideRecordCount||0}}个/{{(customData.baseRecordCount)+(customData.outsideRecordCount)||0}}个</span>
				</div>
				<div class="phone-details">
					<div class="title">订购分钟数<el-tooltip content="套餐包分钟数/加量包分钟数/总订购分钟" placement="top">
							<i class="el-icon-warning-outline"
								style="color: #f27c27;position: relative;top:-4px;left: 6px;cursor: pointer;"></i>
						</el-tooltip></div>
					<span
						class="text">{{customData.packagesCount||0}}分钟/{{customData.outsideCount||0}}分钟/{{(customData.packagesCount)+(customData.outsideCount)||0}}分钟</span>
				</div>
			</div>
			<el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				max-height="600" @selection-change="handleSelectionChange"
				:header-cell-style="{ 'text-align': 'center' }" :row-style="{ height: '20px' }"
				:cell-style="{ padding: '6px' }" stripe v-loading="loading">
				<el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="agentName" label="代理" align="center"
					v-if="isAdmin&&!query.agentId"></el-table-column>
				<el-table-column prop="companyName" label="企业" align="center"
					v-if="(isAdmin||isAgent)&&!query.companyId"></el-table-column>
				<el-table-column prop="phone" label="坐席账号" align="center"></el-table-column>
				<el-table-column prop="cardName" label="品牌" align="center"></el-table-column>
				<el-table-column prop="type" label="类型(套餐包&加量包)" align="center"></el-table-column>
				<el-table-column prop="package" label="销售价格" align="center"></el-table-column>
				<el-table-column prop="priceDiff" label="溢价金额(元)" align="center"></el-table-column>
				<el-table-column prop="createdAt" label="订购时间" align="center">
					<template #default="scope">
						<span>{{scope.row.createdAt}}</span>
					</template>
				</el-table-column>

			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper"
					:current-page="query.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
					:page-size="query.pageSize" :total="pageTotal" @size-change="handleSizeChange"
					@current-change="handlePageChange"></el-pagination>
			</div>

		</div>
	</div>
</template>

<script>
	import {
		fetchDepartment
	} from '../api/index.js';
	import {
		fetchAgent
	} from '../api/agentIndex.js';
	import {
		fetchCompanyByAgentId,
		fetchDefaultCompanies
	} from '../api/companyIndex';
	import {
		packageRaise,
		serverList,
		exportUseRecord,
		packageRaiseExport
	} from '../api/setMeal.js';
	export default {
		name: 'premium',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				query: {
					companyId: '',
					agentId: '',
					phone: '',
					type: '',
					userId: localStorage.getItem('user'),
					startTime: '',
					cardsId: '',
					pageIndex: 1,
					pageSize: 10,
				},
				serverLists: [], //SIPServer服务器的列表
				agents: [],
				companys: [],
				tableData: [],
				contentList: [],
				outsideList: [],
				multipleSelection: [],
				isAdmin: false,
				isAgent: false,
				isNormal: false,
				pageTotal: 0,

				role: '',
				timeArr: '',
				customData: '',
				typeList: [{
					value: '1',
					label: '套餐包'
				}, {
					value: '2',
					label: '加量包'
				}]
			};
		},
		created() {
			this.role = localStorage.getItem('ms_role');
			this.init();
			if (this.role === 'admin') {
				this.isAdmin = true;
				this.isNormal = true;
			}

			if (this.role == 'agent') {
				this.isAgent = true;
				this.isNormal = true;
			}
			this.getTime()
			this.getData();
			this.getServerList();
			this.updatePaginationStyle();
		},
		methods: {
			updatePaginationStyle() {
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .el-pager .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.el-pager .number:hover {
				        color: ${this.theme8} !important;
				    }
					.el-pager .active:hover {
					    color: #fff !important;
					}
					.el-pager .more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			//sip服务器列表
			getServerList() {
				let data = {
					pageIndex: 1,
					pageSize: 30
				}
				serverList(data).then(res => {
					if (res?.code === 200) {
						this.serverLists = res.data.list;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getfetchDefaultCompanies() {
				this.query.companyId = '';
				let data = {
					currentUserId: localStorage.getItem('user'),
					subAgentId: this.query.subAgentId
				};
				fetchDefaultCompanies(data).then(res => {
					this.companys = res.data;

				});
			},



			init() {
				fetchAgent(localStorage.getItem('user')).then(res => {
					this.agents = res.data;
				});
				this.getfetchDefaultCompanies();
			},
			getData() {
				if (this.timeArr === null) {
					this.query.startTime = '';
					this.$message.error('时间不能为空');
				} else {
					this.query.startTime = this.toDateTimeStr(this.timeArr);
				}
				this.loading = true;
				this.query.userId = localStorage.getItem('user');
				packageRaise(this.query).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data.list;
						this.customData = res.customData;
						this.pageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getTime() {
				//时间
				this.timeArr = new Date(new Date())

			},
			toDateTimeStr(date) {
				let y = date.getFullYear();
				let m = date.getMonth() + 1;
				let d = date.getDate();
				if (m < 10) {
					m = '0' + m;
				}
				return y + '-' + m;
			},
			agentChange(agentId) {
				this.query.agentId = agentId;
				this.query.companyId = '';
				this.query.departmentId = '';
				this.query.userId = '';
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				}
			},
			companyChange(companyId) {
				this.query.companyId = companyId;
				this.query.departmentId = '';
				this.query.userId = '';
				let data = {
					companyId: companyId,
					currentUserId: localStorage.getItem('user')
				};
				fetchDepartment(data).then(res => {
					this.departments = res.data;
					this.query.pageIndex = 1;
					// this.getData();
				});
			},


			// 多选操作
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 触发搜索按钮
			handleSearch() {
				this.query.pageIndex = 1;
				this.getData();
			},
			handleSizeChange(val) {
				this.query.pageSize = val;
				this.query.pageIndex = 1; // 重置到第一页
				this.getData();
			},
			// 分页导航
			handlePageChange(val) {
				this.query.pageIndex = val;
				this.getData();
			},



			handleExport() {
				if (this.timeArr === null) {
					this.query.startTime = '';
					this.$message.error('请选择时间段');
				} else {
					let startTime = this.toDateTimeStr(this.timeArr);

					this.query.startTime = this.toDateTimeStr(this.timeArr);
				}
				this.query.userId = localStorage.getItem('user');
				packageRaiseExport(this.query).then(res => {
					this.loading = false;
					const blob = new Blob([res], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
					});
					let downloadElement = document.createElement('a');
					let href = window.URL.createObjectURL(blob);
					downloadElement.href = href;
					let fileName = this.query.startTime + '溢价' + '.xlsx';
					downloadElement.download = fileName;
					document.body.appendChild(downloadElement);
					downloadElement.click();
					document.body.removeChild(downloadElement);
					window.URL.revokeObjectURL(href);
				});
			},
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.down {
		border: 1px solid #dcdfe6;
		background: #4f7afd;
		color: #ffffff;
		transition: 0.1s;
		font-weight: 500;
		padding: 8px 16px;
		font-size: 12px;
		border-radius: 4px;
		margin-left: 10px;

		display: inline-block;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 12px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.grid-con-icon {
		font-size: 50px;
		width: 100px;
		height: 100px;
		text-align: center;
		line-height: 100px;
		color: #fff;
	}

	.phone-details {
		height: 80px;
		width: 20%;
		border-radius: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		padding: 10px 24px;
		background-color: #ecf4ff;

		.title {
			font-size: 16px;
			color: #222;
		}

		.text {
			font-size: 16px;
			color: #222;
			font-weight: 700;
		}
	}

	.grid-cont-right {
		flex: 1;
		text-align: center;
		font-size: 20px;
		font-weight: bold;
		color: #999;
	}

	.grid-content {
		display: flex;
		align-items: center;
		height: 100px;
	}
</style>
<style>
	.import-visible .el-upload {
		width: 100% !important;
		display: flex !important;
		flex-direction: column !important;
		align-items: center !important;
		justify-content: center !important;
	}
</style>